// extracted by mini-css-extract-plugin
module.exports = {"headlightWrapper":"headlight__headlightWrapper__rS1Hz"};